module.exports = __webpack_public_path__ + "static/media/integrations.f425ad5d.svg";